import { render, staticRenderFns } from "./ThreadPage.vue?vue&type=template&id=ffc92d06&scoped=true"
import script from "./ThreadPage.vue?vue&type=script&lang=js"
export * from "./ThreadPage.vue?vue&type=script&lang=js"
import style0 from "./ThreadPage.vue?vue&type=style&index=0&id=ffc92d06&prod&lang=scss&scoped=true"
import style1 from "./ThreadPage.vue?vue&type=style&index=1&id=ffc92d06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc92d06",
  null
  
)

export default component.exports